export default {
    accountTypes: {
        bank: 'Konto w banku',
        creditCard: 'Karta kredytowa',
        cash: 'Gotówka',
        savings: 'Oszczędności',
    },
    intervals: {
        monthly: 'co miesiąc',
        quarterly: 'co kwartał',
        yearly: 'co rok',
    },
    days: {
        today: 'dziś',
        yesterday: 'wczoraj',
        todayHeading: 'Dziś',
        yesterdayHeading: 'Wczoraj',
        untilMonth: 'do {month} {year}',
    },
    due: {
        paid: 'zapłacone',
        skipped: 'pominięte',
        overdue: 'po terminie {n} dzień | po terminie {n} dni | po terminie {n} dni',
        today: 'dziś',
        tomorrow: 'jutro',
        inDays: 'za {n} dni',
    },
    firstSteps: {
        account: {
            title: 'Drugie konto', action: 'Dodaj konto',
            what: 'Gotówka, karta kredytowa albo konto oszczędnościowe — każde ma własne saldo.',
            why: 'Wydatek z gotówki nie zmienia salda w banku. Z osobnymi kontami suma się zgadza, a przelew między nimi nie liczy się jako wydatek.',
        },
        expense: {
            title: 'Pierwszy wydatek', action: 'Dodaj wydatek',
            what: 'Kwota i kategoria — konto, data i opis mają podpowiedzi, nie trzeba ich ruszać.',
            why: 'Każdy wydatek od razu zmniejsza „Do wydania", więc widzisz, ile naprawdę zostało do końca miesiąca.',
        },
        receipt: {
            title: 'Wydatek z paragonu', action: 'Zrób zdjęcie paragonu',
            what: 'Zdjęcie paragonu albo PDF — odczytamy sklep, datę, kwotę i kategorię.',
            why: 'Najszybciej po zakupach: sprawdzasz propozycję, poprawiasz, co trzeba, i dodajesz jednym tapnięciem. Zdjęcie zostaje przy transakcji.',
        },
        dictation: {
            title: 'Podyktuj transakcje', action: 'Podyktuj',
            what: 'Powiedz albo wpisz zdaniem, np. „wczoraj Biedronka 84 zł, dziś paliwo 250".',
            why: 'Kilka transakcji naraz, gdy nadrabiasz zaległości — każdą zobaczysz i poprawisz przed zapisem.',
        },
        income: {
            title: 'Pierwszy wpływ', action: 'Dodaj wpływ',
            what: 'Pensja, zwrot, sprzedaż — wszystko, co przychodzi na konto.',
            why: 'Wpływy powiększają „Do wydania". Pensję, która przychodzi co miesiąc, dodaj też jako wpływ stały w Planach — będzie liczona, zanim wpłynie.',
        },
        transfer: {
            title: 'Przelew między kontami', action: 'Dodaj przelew',
            what: 'Np. wypłata z bankomatu na gotówkę albo spłata karty kredytowej z konta osobistego.',
            why: 'To nie wydatek — pieniądze tylko zmieniają konto. Nie zawyżają wydatków i nie psują sald.',
        },
        plan: {
            title: 'Płatność stała', action: 'Dodaj płatność stałą',
            what: 'Czynsz, prąd, abonament — kwota i dzień miesiąca.',
            why: 'Odlicza się od „Do wydania", zanim ją zapłacisz, więc pieniądze na czynsz się nie rozejdą. W dniu terminu odhaczasz ją jednym tapnięciem.',
        },
        budget: {
            title: 'Budżet na kategorię', action: 'Ustaw budżet',
            what: 'Miesięczny limit na kategorię, np. 1 200 zł na jedzenie.',
            why: 'Przy 80% limitu zobaczysz ostrzeżenie na stronie głównej — zanim będzie za późno.',
        },
        goal: {
            title: 'Cel oszczędnościowy', action: 'Załóż cel',
            what: 'Na co odkładasz i ile — do terminu albo stała kwota co miesiąc.',
            why: 'Portfel policzy, ile odłożyć w tym miesiącu, i odejmie to od „Do wydania". Widzisz postęp i kiedy dojdziesz do celu.',
        },
        loan: {
            title: 'Kredyt', action: 'Dodaj kredyt',
            what: 'Kredyt ratalny albo odnawialny (karta, limit na koncie).',
            why: 'Raty pojawiają się w „Najbliższych" jak płatności stałe, a nadpłaty skracają spłatę — widać, ile jeszcze zostało.',
        },
        statement: {
            title: 'Import wyciągu', action: 'Wczytaj wyciąg',
            what: 'Plik CSV z historią rachunku, pobrany z bankowości internetowej.',
            why: 'Uzupełnisz to, czego brakuje: rozpoznamy, co już jest, co opłaca płatność stałą, a co jest przelewem własnym. Nic się nie zapisze bez Twojego zatwierdzenia.',
        },
        reminders: {
            title: 'Przypomnienia', action: 'Włącz przypomnienia',
            what: 'Powiadomienie na tym urządzeniu przed terminem płatności stałej i w jego dniu.',
            why: 'Żadna płatność nie przejdzie po terminie, nawet gdy nie zaglądasz do Portfela.',
        },
    },
    help: {
        leftToSpend: {
            title: 'Do wydania',
            text: 'Najważniejsza liczba: wpływy minus wydatki minus nieopłacone jeszcze płatności stałe z tego miesiąca. Pod nią — ile to dziennie.',
            more: 'Odliczają się też kwoty, które w tym miesiącu masz odłożyć na cele. Ruch na kontach oszczędnościowych się nie liczy — to nie są pieniądze do wydania.',
        },
        quickAdd: {
            title: 'Wydatek w dwie sekundy',
            text: 'Wydatek, wpływ albo przelew między kontami. W formularzu możesz też podyktować kilka transakcji naraz.',
            more: 'Przelew własny (np. wypłata z bankomatu, spłata karty kredytowej) nie jest wydatkiem — pieniądze tylko zmieniają konto.',
        },
        receipt: {
            title: 'Zdjęcie paragonu',
            text: 'Zrób zdjęcie paragonu albo wybierz PDF — odczytamy sklep, datę, kwotę i kategorię. Sprawdzasz, poprawiasz, co trzeba, i dodajesz jednym tapnięciem. Zdjęcie zostaje przy transakcji.',
        },
        upcoming: {
            title: 'Najbliższe płatności',
            text: 'Płatności stałe i raty na najbliższy miesiąc. Kółko — zapłacone jednym tapnięciem, „Pomiń" — w tym miesiącu nie trzeba.',
            more: 'Zapłacona płatność staje się wydatkiem na jej koncie (albo domyślnym). Dopóki jej nie odhaczysz, i tak odlicza się od „Do wydania".',
        },
        accounts: {
            title: 'Konta',
            text: 'Saldo każdego konta i suma. Tapnij konto, żeby zobaczyć jego transakcje.',
        },
        budgets: {
            title: 'Budżety',
            text: 'Gdy kategoria dobije do 80% limitu, zobaczysz to tutaj — zanim będzie za późno.',
            more: 'Limity ustawiasz w Analizie: kliknij kategorię i wpisz kwotę na miesiąc.',
        },
        setAside: {
            title: 'Odłóż w tym miesiącu',
            text: 'Ile w tym miesiącu odłożyć na każdy cel. „Odłożone" zapisuje przelew własny na konto celu.',
        },
        txFilters: {
            title: 'Transakcje',
            text: 'Cały miesiąc dzień po dniu. Szukaj po kontrahencie, filtruj po koncie i kategorii; strzałki w nagłówku zmieniają miesiąc.',
            more: 'Suma pod filtrami liczy tylko to, co widać. Tapnij transakcję, żeby ją poprawić, podzielić na kategorie albo dodać zdjęcie paragonu.',
        },
        txImport: {
            title: 'Import wyciągu',
            text: 'Wczytaj plik z historią konta z banku — rozpoznamy, co już jest, co opłaca plan, a co jest przelewem własnym. Nic nie zapisze się bez Twojego zatwierdzenia.',
            more: 'Ten sam plik można wczytać ponownie — wiersze, które już są, zostaną pominięte.',
        },
        plansRecurring: {
            title: 'Płatności i wpływy stałe',
            text: 'Czynsz, abonamenty, pensja — raz wpisane, co miesiąc odliczają się od „Do wydania", zanim je zapłacisz albo dostaniesz.',
            more: 'Mogą być co miesiąc, co kwartał albo co rok. Przypomnienie przyjdzie w dniu terminu.',
        },
        plansIncome: {
            title: 'Wpływy stałe',
            text: 'Pensja, świadczenie, czynsz od najemcy — wpływ, który przychodzi regularnie. Zanim go dostaniesz, „Do wydania" już go uwzględnia jako „Jeszcze wpłynie".',
        },
        plansGoals: {
            title: 'Cele oszczędnościowe',
            text: 'Odkładasz na coś do terminu albo stałą kwotę co miesiąc — zobaczysz postęp i ile jeszcze odłożyć.',
            more: 'Pieniądze celu leżą na wybranym koncie (najlepiej oszczędnościowym). Cel może odliczać miesięczną kwotę od „Do wydania", żeby się nie rozeszła.',
        },
        plansLoans: {
            title: 'Kredyty',
            text: 'Raty odhaczasz jak płatności stałe, a nadpłaty skracają spłatę.',
            more: 'Przy kredycie odnawialnym (karta, limit na koncie) rata to kwota, którą planujesz spłacać co miesiąc.',
        },
        analysisResult: {
            title: 'Wynik miesiąca',
            text: 'Wpływy, wydatki i bilans miesiąca finansowego. „Odkładasz" to część wpływów, która nie została wydana.',
        },
        analysisCategories: {
            title: 'Na co idą pieniądze',
            text: 'Wydatki według kategorii z budżetami. Tu ustawiasz miesięczny limit na kategorię.',
            more: 'Budżet może obowiązywać co miesiąc albo tylko w tym jednym. Kreska na pasku to limit.',
        },
        analysisIncome: {
            title: 'Skąd wpływa',
            text: 'Wpływy w tym miesiącu według kategorii. Tapnij kategorię, żeby zobaczyć jej transakcje.',
        },
        analysisTrend: {
            title: 'Miesiąc do miesiąca',
            text: 'Wydatki z ostatnich miesięcy i średnia. Tapnij słupek, żeby przejść do tamtego miesiąca.',
        },
        settingsAccounts: {
            title: 'Konta i kategorie',
            text: 'Dodajesz konta (bank, gotówka, karta kredytowa, oszczędności) i układasz własne kategorie.',
            more: '„Uzgodnij" wpisuje saldo z banku — różnica zapisze się jako korekta. „Wyciąg" wczytuje historię rachunku.',
        },
        settingsCategories: {
            title: 'Kategorie',
            text: 'Własne kategorie wydatków i wpływów. Usunięcie kategorii przenosi jej transakcje do wybranej innej — nic nie zostaje bez kategorii.',
        },
        settingsReminders: {
            title: 'Przypomnienia',
            text: 'Powiadomienie w dniu płatności stałej — żadna nie przejdzie po terminie.',
            more: 'Przypomnienia włącza się osobno na każdym urządzeniu.',
        },
        settingsMonth: {
            title: 'Miesiąc finansowy',
            text: 'Od którego dnia liczy się miesiąc. Jeśli pensja przychodzi 10., ustaw 10 — „Do wydania" i budżety liczą się wtedy od wypłaty do wypłaty.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Portfelu',
            text: 'Ile możesz jeszcze wydać, co trzeba zapłacić i dokąd idą pieniądze. W dwie minuty pokażę Ci, co gdzie jest — możesz to w każdej chwili zamknąć.',
        },
        done: {
            title: 'To wszystko',
            text: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy każdej sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    now: {
        title: 'Teraz',
        add: 'Dodaj',
        addTransaction: 'Dodaj transakcję',
        leftToSpendUntil: 'DO WYDANIA · DO {date}',
        daily: 'to około {amount} dziennie przez {n} dzień | to około {amount} dziennie przez {n} dni | to około {amount} dziennie przez {n} dni',
        overspent: 'Wydatki i zaplanowane płatności przekraczają wpływy w tym miesiącu.',
        startingBalance: 'Na start',
        startingBalanceHint: 'Pierwszy miesiąc w Portfelu: liczy się to, co było na koncie i w gotówce na starcie',
        income: 'Wpływy',
        pendingIncome: 'Jeszcze wpłynie',
        spent: 'Wydane',
        toPay: 'Do zapłaty',
        savings: 'Oszczędności i cele',
        savingsHint: 'Przelewy na oszczędności i to, co jeszcze trzeba w tym miesiącu odłożyć na cele (ruch na kontach oszczędnościowych nie jest do wydania)',
        expense: 'Wydatek',
        incomeOne: 'Wpływ',
        transfer: 'Przelew własny',
        receipt: 'Paragon',
        receiptHint: 'Zdjęcie paragonu albo PDF — odczytamy kwotę i kategorię',
        accounts: 'KONTA',
        manage: 'Zarządzaj',
        upcoming: 'NAJBLIŻSZE',
        overdueCount: '{n} po terminie',
        plans: 'Plany',
        markReceived: '{name}: oznacz jako otrzymane',
        markPaid: '{name}: oznacz jako zapłacone',
        received: 'Otrzymane',
        paid: 'Zapłacone',
        loanInstalment: 'rata kredytu',
        skip: 'Pomiń',
        skipHint: 'Nie trzeba płacić w tym miesiącu',
        allSettled: 'Wszystko na najbliższy miesiąc rozliczone.',
        noPlans: 'Brak płatności stałych. {link} — odliczą się od „Do wydania", zanim je zapłacisz.',
        noPlansLink: 'Dodaj czynsz, abonamenty, pensję',
        settledCount: '{n} już rozliczone',
        setAsideTitle: 'ODŁÓŻ W TYM MIESIĄCU',
        goals: 'Cele',
        ofTotal: '{part} z {total}',
        setAsideAmount: 'Odłożone {amount}',
        setAsideDone: 'odłożone',
        budgets: 'BUDŻETY',
        analysis: 'Analiza',
        overBy: 'ponad o {amount}',
        left: 'zostało {amount}',
        budgetsOk: 'Wszystkie budżety w normie.',
        noBudgets: 'Ustaw limity na kategorie w {link}, a tu zobaczysz ostrzeżenie przy 80%.',
        noBudgetsLink: 'Analizie',
        recent: 'OSTATNIE',
        all: 'Wszystkie',
        receiptPhotos: 'Zdjęcia paragonu: {n}',
        hasReceiptPhoto: 'ma zdjęcie paragonu',
        noTransactions: 'Nic jeszcze nie dodano. Zacznij od pierwszego wydatku — przycisk {button} u góry.',
        flash: {
            received: '„{name}" otrzymane.',
            paid: '„{name}" zapłacone.',
            saveFailed: 'Nie udało się zapisać.',
            setAside: 'Odłożone na „{name}".',
            alreadyOnGoalAccount: 'Konto domyślne to konto celu — przelej z innego konta.',
            setAsideFailed: 'Nie udało się odłożyć.',
            skipped: '„{name}" pominięte w tym miesiącu.',
            skipFailed: 'Nie udało się pominąć.',
            photoFailed: 'Zapisane, ale zdjęć nie udało się wysłać — dodaj je w edycji.',
            transferSaved: 'Przelew zapisany.',
            added: 'Dodane. Do wydania: {amount}',
            saved: 'Zapisane.',
            deleted: 'Usunięte.',
            addedCount: 'Dodane: {n} transakcja. | Dodane: {n} transakcje. | Dodane: {n} transakcji.',
        },
    },
    transactions: {
        title: 'Transakcje',
        add: 'Dodaj',
        loadFailed: 'Nie udało się pobrać transakcji.',
        monthLoadFailed: 'Nie udało się pobrać miesiąca.',
        archivedAccount: '{name} (archiwum)',
        expenses: 'Wydatki',
        income: 'Wpływy',
        instalmentOf: 'rata: {name}',
        overpaymentOf: 'nadpłata: {name}',
        importHint: 'Wczytaj historię rachunku z banku (CSV)',
        import: 'Import wyciągu',
        prevMonth: 'Poprzedni miesiąc',
        nextMonth: 'Następny miesiąc',
        search: 'Szukaj…',
        searchLabel: 'Szukaj po kontrahencie lub notatce',
        allAccounts: 'Wszystkie konta',
        allCategories: 'Wszystkie kategorie',
        allTypes: 'Wydatki i wpływy',
        count: '{n} transakcja | {n} transakcje | {n} transakcji',
        incomeLabel: 'wpływy',
        expensesLabel: 'wydatki',
        ownTransfer: 'przelew własny',
        noMatches: 'Nic nie pasuje do filtrów.',
        empty: 'Brak transakcji w tym miesiącu.',
        flash: {
            photoFailed: 'Zapisane, ale zdjęć nie udało się wysłać — dodaj je w edycji.',
            added: 'Dodane.',
            saved: 'Zapisane.',
            deleted: 'Usunięte.',
            imported: 'Wyciąg zaimportowany.',
        },
    },
    analysis: {
        title: 'Analiza',
        income: 'Wpływy',
        expenses: 'Wydatki',
        balance: 'Bilans',
        saving: 'Odkładasz',
        noIncomeShort: 'brak wpływów',
        whereMoneyGoes: 'NA CO IDĄ PIENIĄDZE',
        clickToBudget: 'kliknij kategorię, żeby ustawić budżet',
        ofBudget: 'z {amount}',
        overBudget: 'Budżet przekroczony o {amount}',
        left: 'Zostało {amount}',
        noExpenses: 'Brak wydatków w tym miesiącu.',
        otherCategory: 'Ustaw budżet innej kategorii',
        whereFrom: 'SKĄD WPŁYWA',
        noIncome: 'Brak wpływów w tym miesiącu.',
        trendTitle: 'WYDATKI · {n} MIESIĘCY',
        average: 'średnio {amount} / mies.',
        budget: {
            limit: 'Limit miesięczny',
            limitHint: 'Ostrzeżenie pojawi się przy 80%.',
            scope: 'Zakres',
            onlyMonth: 'Tylko {month}',
            saved: 'Budżet „{name}" zapisany.',
            saveFailed: 'Nie udało się zapisać budżetu.',
            deleted: 'Budżet „{name}" usunięty.',
            deleteFailed: 'Nie udało się usunąć budżetu.',
            dialogTitle: 'Budżet: {name}',
            deleteSubject: 'Budżet tej kategorii',
        },
        budgetStep: {
            title: 'Ustaw budżet',
            text: 'Kliknij kategorię (albo „Ustaw budżet innej kategorii" pod listą) i wpisz miesięczny limit. Przy 80% zobaczysz ostrzeżenie na stronie głównej.',
        },
    },
    plans: {
        title: 'Plany',
        action: 'Płatność stała',
        add: '+ Dodaj',
        payments: 'PŁATNOŚCI STAŁE',
        paymentsEmpty: 'Czynsz, media, abonamenty, ubezpieczenia — każdą odhaczysz jednym tapnięciem.',
        incomes: 'WPŁYWY STAŁE',
        incomesEmpty: 'Pensja albo inne regularne wpływy — „Do wydania" policzy je, zanim przyjdą.',
        instalmentsLeft: '{n} rata do końca | {n} raty do końca | {n} rat do końca',
        schedule: '{interval}, {day}. dnia',
        until: 'do {month}',
        goals: 'CELE',
        createSavings: 'Utwórz Oszczędności',
        addGoal: '+ Dodaj cel',
        perMonth: '{amount} / mies.',
        goalAchieved: 'Osiągnięty — możesz go wydać i zakończyć.',
        thisMonth: 'W tym miesiącu {part} z {total}',
        atThisPace: 'w tym tempie: {month}',
        setAsideThisMonth: 'w tym miesiącu odłożone',
        notReserved: 'nie odliczane od „Do wydania"',
        goalsEmpty: 'Wakacje, poduszka bezpieczeństwa, nowy telefon — Portfel policzy, ile odkładać co miesiąc, i odejmie to od „Do wydania", zanim pieniądze się rozejdą.',
        finished: 'Zakończone:',
        loans: 'KREDYTY',
        addLoan: '+ Dodaj kredyt',
        loansMonthly: 'raty {amount} / mies.',
        revolvingRate: 'odnawialny · {rate}%',
        installmentLoan: 'ratalny',
        ends: 'koniec {date}',
        instalment: 'rata',
        principal: 'Kapitał',
        interestLeft: 'Odsetki do końca',
        payInstalment: 'Zapłać ratę · {due}',
        instalmentPaid: 'rata w tym miesiącu zapłacona',
        payNext: 'Zapłać kolejną ratę',
        loansEmpty: 'Raty kredytów działają jak płatności stałe, a do tego Portfel liczy kapitał, odsetki i efekt nadpłat. Karta kredytowa to konto — dodasz ją w ustawieniach.',
        form: {
            expenses: 'Wydatki',
            incomes: 'Wpływy',
            name: 'Nazwa',
            namePlaceholder: 'np. Czynsz',
            namePlaceholderIncome: 'np. Pensja',
            kind: 'Rodzaj',
            kindPayment: 'Płatność',
            kindIncome: 'Wpływ',
            amount: 'Kwota',
            category: 'Kategoria',
            interval: 'Jak często',
            dueDay: 'Dzień miesiąca',
            startMonth: 'Od miesiąca',
            startMonthHint: 'Kwartalne i roczne liczą się od tego miesiąca.',
            endMonth: 'Do miesiąca',
            endMonthHint: 'Puste = bez końca.',
            fromAccount: 'Z konta',
            defaultAccount: 'Konto domyślne',
        },
        loan: {
            namePlaceholder: 'np. Hipoteka PKO',
            installment: 'Ratalny',
            revolving: 'Odnawialny / limit',
            installmentAmount: 'Rata / spłata miesięczna',
            capital: 'Zostało kapitału',
            capitalHint: 'Z aplikacji banku — z niego liczymy odsetki.',
            interestRate: 'Oprocentowanie',
            paymentDay: 'Dzień raty',
            nextPayment: 'Najbliższa rata',
            nextPaymentHint: 'Puste = najbliższy dzień raty.',
            lastPayment: 'Ostatnia rata',
            installmentType: 'Raty',
            equal: 'Równe',
            decreasing: 'Malejące',
            minimumPayment: 'Spłata minimalna',
            category: 'Kategoria rat',
        },
        overpay: {
            button: 'Nadpłać',
            amount: 'Kwota nadpłaty',
            date: 'Data',
            mode: 'Co robi bank',
            shorten: 'Skraca okres (ta sama rata)',
            lower: 'Obniża ratę (ten sam koniec)',
            capitalOnly: 'Tylko zmniejsza kapitał',
            account: 'Konto kredytu albo domyślne',
        },
        goal: {
            name: 'Na co',
            namePlaceholder: 'np. Wakacje',
            target: 'Ile odłożyć',
            pace: 'Jak',
            byDeadline: 'Do terminu',
            fixedMonthly: 'Stała kwota co miesiąc',
            monthly: 'Co miesiąc',
            initial: 'Już odłożone',
            account: 'Na koncie',
            noSavingsAccount: 'Nie masz konta oszczędnościowego — „Utwórz Oszczędności" niżej.',
            reserve: 'Do wydania',
            reserveHint: 'Odliczaj tegomiesięczną wpłatę, zanim ją zrobię',
            archived: 'Zakończony',
            archivedHint: 'Cel zrealizowany albo porzucony — zostaje w historii',
        },
        dialog: {
            editPlan: 'Edytuj plan',
            newIncome: 'Nowy wpływ stały',
            newPayment: 'Nowa płatność stała',
            editLoan: 'Edytuj kredyt',
            newLoan: 'Nowy kredyt',
            editGoal: 'Edytuj cel',
            newGoal: 'Nowy cel',
            overpay: 'Nadpłata: {name}',
        },
        flash: {
            alreadySettled: 'Już rozliczone w tym miesiącu.',
            saveFailed: 'Nie udało się zapisać.',
            settled: '„{name}" rozliczone.',
            instalmentPaid: 'Rata „{name}" zapłacona.',
            planSaved: 'Plan zapisany.',
            planSaveFailed: 'Nie udało się zapisać planu.',
            planDeleted: 'Plan usunięty. Jego transakcje zostały.',
            planDeleteFailed: 'Nie udało się usunąć planu.',
            loanSaved: 'Kredyt zapisany.',
            loanSaveFailed: 'Nie udało się zapisać kredytu.',
            loanDeleted: 'Kredyt usunięty. Transakcje rat zostały.',
            loanDeleteFailed: 'Nie udało się usunąć kredytu.',
            overpaySaved: 'Nadpłata zapisana — kredyt przeliczony.',
            overpaySaveFailed: 'Nie udało się zapisać nadpłaty.',
            goalSaved: 'Cel zapisany.',
            goalSaveFailed: 'Nie udało się zapisać celu.',
            goalDeleted: 'Cel usunięty. Przelewy zostały.',
            goalDeleteFailed: 'Nie udało się usunąć celu.',
            savingsCreated: 'Dodano konto „{name}". Saldo uzgodnisz w ustawieniach.',
            accountAddFailed: 'Nie udało się dodać konta.',
        },
    },
    settings: {
        title: 'Ustawienia Portfela',
        save: 'Zapisz',
        addAccount: '+ Dodaj konto',
        default: 'domyślne',
        archive: 'archiwum',
        limit: 'limit {amount}',
        statement: 'Wyciąg',
        reconcileButton: 'Uzgodnij',
        reconcileHint: 'Wpisz saldo z banku',
        creditCardNote: 'Karta kredytowa to konto: zakupy kartą są wydatkami, a spłata karty z konta osobistego to przelew własny.',
        expenseCategories: 'KATEGORIE WYDATKÓW',
        incomeCategories: 'KATEGORIE WPŁYWÓW',
        untrackedHint: 'Używana przy uzgadnianiu salda',
        account: {
            name: 'Nazwa',
            namePlaceholder: 'np. mBank osobiste',
            type: 'Rodzaj',
            openingBalance: 'Saldo początkowe',
            openingBalanceHint: 'Na karcie kredytowej dług wpisz z minusem.',
            creditLimit: 'Limit karty',
            number: 'Numer rachunku',
            numberPlaceholder: 'np. ostatnie 4 cyfry',
            numberHint: 'Pomaga rozpoznać przelewy własne w wyciągach.',
            isDefault: 'Domyślne',
            isDefaultHint: 'Domyślne przy dodawaniu',
            archived: 'Archiwum',
            archivedHint: 'Ukryj (historia zostaje)',
        },
        reconcile: {
            balance: 'Ile jest teraz na koncie',
            hint: 'Różnica zapisze się jako transakcja w kategorii „Nieśledzone".',
            matches: 'Saldo się zgadza.',
            done: 'Saldo uzgodnione ({amount} jako nieśledzone).',
        },
        category: {
            expenses: 'Wydatki',
            income: 'Wpływy',
            moveTo: 'Przenieś transakcje, plany i budżety do',
        },
        history: {
            title: 'HISTORIA Z FINANSÓW',
            text: 'W Finansach: {list}. Możesz je raz skopiować — Finanse zostaną bez zmian. Później ta opcja znika.',
            expenses: '{n} wydatek | {n} wydatki | {n} wydatków',
            incomes: '{n} przychód | {n} przychody | {n} przychodów',
            fixedPayments: '{n} płatność stała | {n} płatności stałe | {n} płatności stałych',
            loans: '{n} kredyt | {n} kredyty | {n} kredytów',
            copying: 'Kopiuję…',
            copy: 'Skopiuj historię',
            copied: 'Skopiowano historię ({n} transakcja). Sprawdź saldo konta i w razie potrzeby je uzgodnij. | Skopiowano historię ({n} transakcje). Sprawdź saldo konta i w razie potrzeby je uzgodnij. | Skopiowano historię ({n} transakcji). Sprawdź saldo konta i w razie potrzeby je uzgodnij.',
            copyFailed: 'Nie udało się skopiować historii.',
        },
        push: {
            title: 'PRZYPOMNIENIA O PŁATNOŚCIACH',
            intro: 'Dzień przed terminem, w dniu terminu i raz po terminie, jeśli płatność dalej nie jest odhaczona. Płatności z jednego dnia przychodzą w jednym powiadomieniu.',
            noServer: 'Serwer nie ma jeszcze włączonych przypomnień push. Sygnały o płatnościach i tak widać w dzwoneczku na górnym pasku.',
            iphone: 'Na iPhonie przypomnienia działają po dodaniu Rountine do ekranu głównego (Udostępnij → Do ekranu początkowego) i otwarciu stamtąd.',
            unsupported: 'Ta przeglądarka nie obsługuje powiadomień push.',
            turnOff: 'Wyłącz na tym urządzeniu',
            turnOn: 'Włącz na tym urządzeniu',
            onHere: 'włączone tutaj',
            test: 'Wyślij test',
            hour: 'O godzinie',
            dayBefore: 'także dzień wcześniej',
            devices: 'Urządzenia: {list}',
            device: 'urządzenie',
            enabled: 'Przypomnienia włączone na tym urządzeniu.',
            disabled: 'Przypomnienia wyłączone na tym urządzeniu.',
            blocked: 'Przeglądarka blokuje powiadomienia dla Rountine — odblokuj je w ustawieniach strony i spróbuj jeszcze raz.',
            dismissed: 'Bez zgody przeglądarki przypomnienia nie przyjdą.',
            enableFailed: 'Nie udało się włączyć przypomnień.',
            testSent: 'Wysłane na {n} urządzenie. | Wysłane na {n} urządzenia. | Wysłane na {n} urządzenia.',
            testNone: 'Żadne urządzenie nie odebrało — włącz przypomnienia ponownie.',
            testFailed: 'Nie udało się wysłać testu.',
        },
        month: {
            title: 'MIESIĄC FINANSOWY',
            startsOn: 'Zaczyna się dnia',
            hint: 'Jeśli pensja przychodzi np. 10., ustaw 10 — budżety i „Do wydania" liczą się wtedy od wypłaty do wypłaty.',
        },
        remindersStep: {
            title: 'Włącz przypomnienia',
            text: 'Tapnij „Włącz na tym urządzeniu" i zezwól na powiadomienia. Na każdym telefonie i komputerze włącza się je osobno.',
        },
        dialog: {
            editAccount: 'Edytuj konto',
            newAccount: 'Nowe konto',
            reconcile: 'Uzgodnij saldo: {name}',
            editCategory: 'Edytuj kategorię',
            newCategory: 'Nowa kategoria',
            removeCategory: 'Usuń kategorię „{name}”',
            removeAndMove: 'Usuń i przenieś',
        },
        flash: {
            hasTransactions: 'Konto ma transakcje — zarchiwizuj je zamiast usuwać.',
            saveFailed: 'Nie udało się zapisać.',
            saved: 'Zapisane.',
            accountSaved: 'Konto zapisane.',
            accountDeleted: 'Konto usunięte.',
            categorySaved: 'Kategoria zapisana.',
            categoryDeleted: 'Kategoria „{name}" usunięta.',
            monthSaved: 'Zapisane. „Do wydania" liczy się teraz od tego dnia.',
            dayRange: 'Dzień musi być od 1 do 31.',
        },
    },
    push: {
        browser: 'Przeglądarka',
    },
    quickAdd: {
        notFromGoal: 'Nie z celu',
        autoGoal: 'Automatycznie ({name})',
        auto: 'Automatycznie',
        noGoal: 'Bez celu',
        deposit: 'Wpłata: {name}',
        withdrawal: 'Wypłata: {name}',
        saveFailed: 'Nie udało się zapisać.',
        onlyLastInstalment: 'Można cofnąć tylko ostatnią zapłaconą ratę kredytu.',
        deleteFailed: 'Nie udało się usunąć.',
        dictateHint: 'Podyktuj — kilka transakcji naraz',
        dictateLabel: 'Podyktuj transakcje',
        dictate: 'Podyktuj',
        receiptHint: 'Paragon — zdjęcie albo PDF',
        receiptLabel: 'Dodaj z paragonu',
        close: 'Zamknij',
        toAccount: 'Na konto',
        needsTwoAccounts: 'Przelew własny wymaga dwóch kont — dodaj je w ustawieniach Portfela.',
        goal: 'Cel',
        split: 'Podziel na kategorie',
        other: 'Inna…',
        pickCategory: 'Wybierz kategorię',
        noIncomeCategories: 'Brak kategorii wpływów — dodaj je w ustawieniach Portfela.',
        noExpenseCategories: 'Brak kategorii wydatków — dodaj je w ustawieniach Portfela.',
        splitTitle: 'Podział',
        splitOk: 'Zgadza się',
        splitMissing: 'Brakuje {amount}',
        splitTooMuch: 'Za dużo o {amount}',
        partAmount: 'Kwota części {n}',
        removePart: 'Usuń część {n}',
        addPart: '+ Część',
        fillRemainder: 'Resztę do ostatniej',
        fromWhom: 'Od kogo',
        where: 'Gdzie',
        optional: 'opcjonalnie',
        fromWhomPlaceholder: 'np. pracodawca',
        wherePlaceholder: 'np. Biedronka',
        when: 'Kiedy',
        account: 'Konto',
        fromGoal: 'Z celu',
        fromGoalHint: 'Wydatek z pieniędzy celu zmniejszy odłożoną kwotę.',
        addNote: '+ Notatka',
        note: 'Notatka',
        pays: 'Opłaca: {name} ({period})',
        instalmentOf: 'Rata: {name}',
        overpaymentOf: 'Nadpłata: {name}',
        delete: 'Usuń',
        saving: 'Zapisuję…',
        transferAmount: 'Przelej {amount}',
        addAmount: 'Dodaj {amount}',
        transferNote: 'Przelew własny zmienia salda {from} i {to}, ale nie jest wydatkiem ani wpływem.',
        loanUndo: 'Rata albo nadpłata zostanie cofnięta na kredycie.',
        cannotUndo: 'Tego nie da się cofnąć.',
    },
    ai: {
        invalidInput: 'Niepoprawne dane wejściowe.',
        noResponse: 'Usługa AI nie odpowiedziała — spróbuj ponownie.',
        notConfigured: 'AI nie jest skonfigurowane na serwerze.',
        micDenied: 'Przeglądarka nie ma dostępu do mikrofonu.',
        micFailed: 'Nie udało się włączyć mikrofonu.',
        noSound: 'Nic nie słyszę — sprawdź mikrofon.',
        transcribing: 'Rozpoznaję mowę…',
        noSpeech: 'Nie rozpoznano mowy — spróbuj jeszcze raz.',
        uploadFailed: 'Nie udało się wysłać nagrania.',
        analyzing: 'Rozpoznaję transakcje…',
        analyzeFailed: 'Nie udało się rozpoznać transakcji.',
        readingMany: 'Czytam {n} paragony…',
        readingOne: 'Czytam paragon…',
        receiptFailed: 'Nie udało się odczytać paragonu.',
        noAmount: 'Nie znalazłem żadnej kwoty — powiedz np. „pizza 45 zł".',
        itemError: 'Pozycja {n}: {error}',
        reviewTitle: 'Sprawdź {n} transakcję | Sprawdź {n} transakcje | Sprawdź {n} transakcji',
        stopRecording: 'Zakończ nagrywanie',
        record: 'Nagrywaj',
        listening: 'Słucham… {s} s — dotknij, gdy skończysz',
        voiceExample: 'np. „pizza 45 wczoraj, paliwo 280 kartą, a od mamy 200"',
        orType: 'albo wpisz',
        textPlaceholder: 'kawa 14, obiad 38 kartą',
        analyze: 'Rozpoznaj',
        takePhoto: 'Zrób zdjęcie albo wybierz plik',
        fileTypes: 'zdjęcie, zrzut ekranu albo PDF; do 5 naraz',
        extraNote: 'Dopisek',
        extraNotePlaceholder: 'np. płaciłem kartą, data 12.10',
        quote: '„{text}"',
        receiptWord: 'paragon',
        restore: 'Przywróć',
        toExpense: 'Wpływ — zmień na wydatek',
        toIncome: 'Wydatek — zmień na wpływ',
        amountN: 'Kwota {n}',
        oneCategoryHint: 'Zamień podział na jedną kategorię',
        oneCategory: 'jedna kategoria',
        whereN: 'Gdzie {n}',
        dateN: 'Data {n}',
        incomplete: 'Uzupełnij kwotę i kategorię.',
        incompleteSplit: 'Uzupełnij kwotę i kategorię (podział nie zgadza się z kwotą).',
        back: 'Wstecz',
        total: 'razem {amount}',
        addAll: 'Dodaj wszystkie',
    },
    attachments: {
        unsupported: 'Ten format zdjęcia nie jest obsługiwany — zrób zrzut albo zdjęcie w JPEG.',
        addFailed: 'Nie udało się dodać zdjęcia.',
        openFailed: 'Nie udało się otworzyć pliku.',
        deleteFailed: 'Nie udało się usunąć zdjęcia.',
        open: 'Otwórz {name}',
        remove: 'Usuń {name}',
        uploading: 'Wysyłam…',
        receiptPhoto: 'Zdjęcie paragonu',
    },
    setup: {
        rent: 'Czynsz',
        electricity: 'Prąd',
        salaryName: 'Pensja',
        saveFailed: 'Nie udało się zapisać — spróbuj jeszcze raz.',
        step: 'KROK {n} Z {total}',
        balanceTitle: 'Ile masz teraz na koncie?',
        balanceText: 'Od tej kwoty Portfel liczy saldo. Później dodasz kolejne konta — kartę, gotówkę, oszczędności.',
        balanceLabel: 'Saldo konta głównego',
        historyTitle: 'Masz już dane w Finansach',
        historyText: '{list}. Możesz je raz skopiować do Portfela — Finanse zostaną bez zmian, a dalej oba moduły żyją osobno.',
        copyAndStart: 'Skopiuj historię i zacznij',
        startFresh: 'Zacznij od zera',
        next: 'Dalej',
        salaryTitle: 'Kiedy dostajesz pensję?',
        salaryText: 'Zanim przyjdzie, Portfel i tak wliczy ją do „Do wydania" — początek miesiąca nie będzie na minusie.',
        netAmount: 'Kwota na rękę',
        netAmountPlaceholder: 'np. 7500',
        day: 'Dzień',
        paymentsTitle: 'Co płacisz co miesiąc?',
        paymentsText: 'Czynsz, media, abonamenty. Każdą odhaczysz jednym tapnięciem, a do tego czasu jest odliczona od „Do wydania". Kredyty dodasz w Planach.',
        paymentName: 'Nazwa płatności {n}',
        paymentAmount: 'Kwota płatności {n}',
        paymentDay: 'Dzień płatności {n}',
        dayPlaceholder: 'dzień',
        addPayment: '+ Kolejna płatność',
        done: 'Gotowe',
    },
    statement: {
        firstImport: '{name} (pierwszy import)',
        readingWithColumns: 'Czytam z tymi kolumnami…',
        readingFile: 'Czytam plik…',
        columnsNotRecognised: 'Nie udało się rozpoznać kolumn automatycznie — wskaż je na próbce poniżej.',
        noMovements: 'Z tymi kolumnami nie odczytałem żadnej operacji — popraw je poniżej.',
        noOperations: 'Nie znalazłem operacji w pliku.',
        readFailed: 'Nie udało się odczytać pliku.',
        roles: {
            date: 'Data',
            amount: 'Kwota (±)',
            debit: 'Obciążenie',
            credit: 'Uznanie',
            counterparty: 'Kontrahent',
            description: 'Opis',
            balance: 'Saldo po',
        },
        actions: {
            existing: 'Już jest',
            plan: 'Opłaca plan',
            loan: 'Rata kredytu',
            transfer: 'Przelew własny',
            new: 'Nowa',
            skip: 'Pomiń',
        },
        newTransaction: 'Nowa transakcja',
        ownTransferEllipsis: 'Przelew własny…',
        saveFailed: 'Nie udało się zapisać — nic nie zostało zmienione.',
        reconciling: 'Uzgadniam…',
        reconcileFailed: 'Nie udało się uzgodnić salda.',
        mappingTitle: 'Które kolumny są czym?',
        reviewTitle: 'Wyciąg: {name}',
        doneTitle: 'Zaimportowane',
        intro: 'Pobierz w banku historię rachunku jako CSV i wybierz ją tutaj. Nic się nie zapisze, zanim nie sprawdzisz podglądu; wiersze zaimportowane wcześniej Portfel pominie sam.',
        chooseFile: 'Wybierz plik CSV',
        banks: 'PKO, mBank, ING, Santander, Pekao, Millennium i inne',
        row: 'wiersz',
        headerRow: 'Nagłówek w wierszu',
        dateFormat: 'Format daty',
        decimalSeparator: 'Grosze po',
        comma: 'przecinku',
        dot: 'kropce',
        negate: 'wydatki są na plusie',
        readWithColumns: 'Czytaj z tymi kolumnami',
        alreadyImported: '{n} wiersz był już zaimportowane | {n} wiersze były już zaimportowane | {n} wierszy było już zaimportowane',
        columns: 'kolumny',
        whichAccount: 'Na które konto',
        rulesNote: 'Kategorie, które tu poprawisz, zapamiętają się jako reguły dla tego kontrahenta.',
        otherFile: 'Inny plik',
        importButton: 'Importuj',
        result: {
            new: '{n} nowa transakcja | {n} nowe transakcje | {n} nowych transakcji',
            existing: '{n} połączona z wpisami | {n} połączone z wpisami | {n} połączonych z wpisami',
            paid: '{n} opłacona płatność | {n} opłacone płatności | {n} opłaconych płatności',
            transfer: '{n} przelew własny | {n} przelewy własne | {n} przelewów własnych',
            matches: 'Saldo zgadza się z bankiem: {amount} na {date}.',
            mismatch: 'Bank pokazuje {bank} na {date}, Portfel {wallet} (różnica {diff}).',
            reconcile: 'Uzgodnij saldo z bankiem',
            reconcileNote: 'Różnica zapisze się jako „Nieśledzone" — zwykle to wydatki sprzed pierwszego importu albo saldo początkowe wpisane z pamięci.',
        },
    },
};
